import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeliveryTruck2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "delivery-truck-2" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25,13.5V6a1.5,1.5,0,0,0-1.5-1.5h-12A1.5,1.5,0,0,0,8.25,6v6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,12V6h-3a4.5,4.5,0,0,0-4.5,4.5v6A1.5,1.5,0,0,0,2.25,18H3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,12h3a1.5,1.5,0,0,0,1.5-1.5V6"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 7.5,
			cy: 17.25,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 19.5,
			cy: 17.25,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 18,
			x2: 15,
			y2: 18
		})
	]
});
export default SvgDeliveryTruck2;
